// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__SJ39x","sendOtp":"AuthorizeToLogin_sendOtp__2UBg4"};